import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { scrollToTopInstant } from '../../utils/scrollToTop';
import PaymentModal from '../PaymentModal/PaymentModal';
import { useTranslation } from '../../hooks/useTranslation';

const Sidebar = () => {
  const t = useTranslation();
  const [paymentModal, setPaymentModal] = useState({ isOpen: false, provider: null });

  const closePaymentModal = () => setPaymentModal({ isOpen: false, provider: null });

  const links = [
    { to: '/sinksar',      icon: '📖', key: 'sidebar.sinksar' },
    { to: '/bahirehasab',  icon: '📅', key: 'sidebar.bahirehasab' },
    { to: '/gitsawie',     icon: '✝️', key: 'sidebar.gitsawe' },
    { to: '/wudasie',      icon: '🙏', key: 'sidebar.wudasie' },
    { to: '/bible',        icon: '📚', key: 'sidebar.bible' },
    { to: '/seatat',       icon: '⏰', key: 'sidebar.seatat' },
    { to: '/hibuat',       icon: '👥', key: 'sidebar.hibuat' },
    { to: '/books',        icon: '📚', key: 'sidebar.books' },
    { to: '/mahlet',       icon: '📖', key: 'sidebar.mahlet' },
    { to: '/filseta',      icon: '📖', key: 'sidebar.filseta' },
    { to: '/news',         icon: '📰', key: 'sidebar.news' },
    { to: '/posting',      icon: '📝', key: 'sidebar.posting' },
    { to: '/admin',        icon: '⚙️', key: 'sidebar.admin' },
    { to: '/bookmarks',    icon: '🔖', key: 'sidebar.bookmarks' },
    { to: '/notes',        icon: '📝', key: 'sidebar.notes' },
    { to: '/projects',     icon: '🗂️', key: 'sidebar.projects' },
  ];

  return (
    <>
      <div className="sidebar">
        <div className="sidebar-header">
          <h3>{t('sidebar.title')}</h3>
          <p>{t('sidebar.subtitle')}</p>
        </div>

        <div className="sidebar-options">
          {links.map(({ to, icon, key }) => (
            <NavLink key={to} className="sidebar-option" to={to} onClick={scrollToTopInstant}>
              <span className="option-icon">{icon}</span>
              <span className="option-text">{t(key)}</span>
            </NavLink>
          ))}
        </div>



        <div className="sidebar-footer">
          <p>ስብሐት ለእግዚአብሔር</p>
          <p>ወለወላዲቱ ድንግል</p>
          <p>ወለመስቀሉ ክቡር አሜን።</p>
        </div>
      </div>

      <PaymentModal
        isOpen={paymentModal.isOpen}
        onClose={closePaymentModal}
        provider={paymentModal.provider}
      />
    </>
  );
};

export default Sidebar;